var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "my-4" }, [_vm._v(" Preview ")]),
    _c("div", { staticClass: " flex rounded-md" }, [
      _c(
        "div",
        { staticClass: "shadow-md bg-white text-sm rounded-md relative" },
        [
          _c(
            "div",
            {
              staticClass: "text-white w-64",
              attrs: { id: "carthike-chat-widget" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "chat-widget-header rounded-t-md p-4",
                  style: {
                    backgroundColor: _vm.config.colors.widgetHeaderColor
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "chat-widget-close-btn absolute right-4",
                      staticStyle: { width: "20px" },
                      style: { color: _vm.config.colors.widgetHeaderTextColor },
                      attrs: { id: "chat-widget-close-icon" }
                    },
                    [
                      _c("img", {
                        staticStyle: { display: "table-row" },
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/close.svg?v=1614675365"
                        }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "chat-widget-title text-2xl",
                      style: { color: _vm.config.colors.widgetHeaderTextColor }
                    },
                    [_vm._v(" " + _vm._s(_vm.config.texts.widgetTitle) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "chat-widget-description text-base",
                      style: { color: _vm.config.colors.widgetHeaderTextColor }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.config.texts.widgetDescription) + " "
                      )
                    ]
                  )
                ]
              ),
              _c("div", { staticClass: "chat-cont text-black" }, [
                _c(
                  "div",
                  _vm._l(_vm.config.additionalAgents, function(agent, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "chat-list-cont flex p-4" },
                      [
                        _c("div", { staticClass: "chat-user-avatar" }, [
                          _c("img", {
                            staticClass: "avatar-theme-301",
                            staticStyle: {
                              height: "55px",
                              width: "55px",
                              "border-radius": "50%"
                            },
                            attrs: { src: agent.avatarUrl }
                          })
                        ]),
                        _c("div", { staticClass: "chat-user-meta pl-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "chat-user-name text-gray-600 capitalize text-lg"
                            },
                            [_vm._v(" " + _vm._s(agent.name) + " ")]
                          ),
                          _c(
                            "p",
                            { staticClass: "chat-user-desc text-gray-400" },
                            [_vm._v(" " + _vm._s(agent.description) + " ")]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }